// @flow
import * as React from 'react'
import glamorous from 'glamorous'
import { transition } from 'style'

import type { ContentfulSizes } from 'types'

const Background = glamorous.div({
  ...transition.slow('filter'),
  transform: 'scale(1.03)',
  position: 'absolute',
  overflow: 'hidden',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPositionY: '80%',
  zIndex: -1,
  ':after': {
    content: "''",
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.7)',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 0,
  },
})

type Props = {
  sizes: ContentfulSizes,
}

type State = {
  src: string,
  blur: number,
}

class BackgroundImage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const {
      sizes: { base64 = '' },
    } = this.props

    this.state = {
      src: base64,
      blur: 5,
    }
  }

  componentDidMount() {
    const {
      sizes: { src = '' },
    } = this.props
    const image = new Image()
    image.addEventListener('load', () => {
      this.imageLoaded()
    })
    image.src = src
  }

  imageLoaded = () => {
    const {
      sizes: { src },
    } = this.props
    this.setState({ src, blur: 0 })
  }

  render() {
    const { blur, src } = this.state
    return (
      <Background
        style={{ backgroundImage: `url(${src})`, filter: `blur(${blur}px)` }}
      />
    )
  }
}

export default BackgroundImage



// WEBPACK FOOTER //
// ./src/components/BackgroundImage.js